export type LoginComplianceProfile = "eu_gdpr" | "us_hipaa" | "global";

export const LOGIN_COMPLIANCE_PROFILES: readonly LoginComplianceProfile[] = [
  "eu_gdpr",
  "us_hipaa",
  "global",
] as const;

const PROFILE_SET = new Set<string>(LOGIN_COMPLIANCE_PROFILES);

export function isLoginComplianceProfile(
  value: unknown,
): value is LoginComplianceProfile {
  return typeof value === "string" && PROFILE_SET.has(value);
}

function readDevOnlyComplianceProfileEnvDefault(): LoginComplianceProfile | undefined {
  if (import.meta.env.PROD) {
    return undefined;
  }

  const envDefault = import.meta.env.VITE_DEFAULT_COMPLIANCE_PROFILE;
  return isLoginComplianceProfile(envDefault) ? envDefault : undefined;
}

export function resolveLoginComplianceProfile(input?: {
  orgProfile?: unknown;
  envDefault?: unknown;
}): LoginComplianceProfile {
  if (isLoginComplianceProfile(input?.orgProfile)) {
    return input.orgProfile;
  }

  const explicitEnvDefault = isLoginComplianceProfile(input?.envDefault)
    ? input.envDefault
    : undefined;
  const envDefault =
    explicitEnvDefault ?? readDevOnlyComplianceProfileEnvDefault();
  if (envDefault) {
    return envDefault;
  }

  return "global";
}

export function getLoginConsentPolicyVersion(
  profile: LoginComplianceProfile,
): string {
  switch (profile) {
    case "eu_gdpr":
      return "2026-07-08-eu";
    case "us_hipaa":
      return "2026-07-08-us";
    default:
      return "2026-07-08-global";
  }
}
